<template>
    <div class="ov">
        <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
        <van-field v-model="value" label="订单号" placeholder="请输入" />
        <van-button @click="ti" type="primary"  size="large">退款提交</van-button>
        <van-field v-model="value1" label="订单号" placeholder="请输入" />
        <van-button @click="ti1" type="primary"  size="large">微信支付提交</van-button>
        <van-field v-model="value2" label="订单号" placeholder="请输入" />
        <van-button @click="ti2" type="primary"  size="large">支付宝支付提交</van-button>
        <!-- <img src="../../assets/my/zc.jpg" alt="">
        <div @click="go" class="dian"></div>
        <div @click="go" class="dian1"></div>
        <div class="f">
            <p>支付成功</p>
            <p>交易说明：<span>开通鲸会员</span></p>
            <p>交易订单号：<span>{{d1}}</span></p>
            <p>商户订单号：<span>{{d2}}</span></p>
        </div> -->
    </div>
</template>
<script>
import Vue from 'vue';
import { Field ,Button,NavBar} from 'vant';
import jsBridge from '../../config/jsbridge-mini.js'

Vue.use(Field).use(Button).use(NavBar);
    export default{
          created(){
          
        },
        data(){
            return{
                d1:'',
                d2: '',
                value:'',
                value1:'',
                value2:'',

            }
        },
      
        methods :{
go(){
    // this.$router.push('my')
  location.href='https://nm.huokongjian.net/#/my'
            },
            onClickLeft () {
        this.$router.go(-1)
            },
            ti () {
                this.axios.post('returnmoney',  { return_no:this.value  }).then(res => {
            console.log(res)
            
          }).catch(ref => { })
            },
            ti1 () {
                this.axios.post('wxgetinfo',  {order_id:this.value1,type:2 }).then(res => {
            console.log(res)
            jsBridge.wxPay({
                appid : res.data.info.appid,
  //商户号
  partnerid: res.data.info.partnerid,
  //预支付交易会话ID
  prepayid :res.data.info.prepayid ,
  //扩展字段
  package  :res.data.info.package,
  //随机字符串
  noncestr : res.data.info.noncestr,
  //时间戳（单位是秒，不是毫秒，切记）
  timestamp: res.data.info.timestamp,
  //签名
  sign     : res.data.info.sign 
 }, function (succ, text) {
 let a= JSON.parse(text).errCode
 
 if(a==0){
  location.href='https://nm.huokongjian.net/#/orderList'
 
 }
 
 
 
 });
          }).catch(ref => { })
            },
            ti2 () {
                this.axios.post('aliorderstring',  { order_id:this.value2,type:2  }).then(res => {
            console.log(res)
            let red= res.data.orderStr
       jsBridge.aliPay({
 orderString:red
 }, function (succ, text) {
   if (succ) {
   location.href='https://nm.huokongjian.net/#/orderList'
   } else {    
     
   }
 })
          }).catch(ref => { })
      },
        }
    }
</script>
<style scoped>
.ov{
    height: 100%;
    padding-top: 1.5rem;
    /* background-color: #eabd79; */
}
.dian{
    position: fixed;
    width: 3rem;
    height: 3rem;
    /* background-color: #f99; */
    top: 0;
    right: 0;
}
.dian1{
    position: fixed;
    width: 5rem;
    height: 4rem;
    /* background-color: #f99; */
    top: 5rem;
    right: 2rem;
}
.f{
    /* padding-top: 4rem; */
    position: fixed;
    top: 2.9rem;
    left: 1.5rem;
   width: 78%;
}
 p{
        line-height: 0.45rem;
    }
    span{
        float: right;
    }
</style>